import { createFileRoute } from '@tanstack/react-router'
import { match } from 'ts-pattern'

import { api } from '@/api'
import RecapClassificationsBPPtionsPage from '@/components/pages/guest/_recap-class/containers/recap-classifications-bpp-page'
import { useFilters } from '@/components/pages/guest/_recap-class/state/filters-atom'
import { searchParamsSchema } from '@/components/pages/guest/_recap-class/types'

export const Route = createFileRoute('/_guest/guest/recap-classifications-bpp')(
  {
    beforeLoad: async ({ search, context: { queryClient } }) => {
      if (search.tab === 'national') {
        await queryClient
          .ensureQueryData(api.guest.recapExtClass.national())
          .catch(console.error)
      }

      if (search.tab === 'province') {
        if (search.province_code) {
          await queryClient
            .ensureQueryData(
              api.guest.recapExtClass.province(search.province_code)
            )
            .catch(console.error)
        }
      }

      if (search.tab === 'city') {
        if (search.province_code && search.city_code) {
          await queryClient
            .ensureQueryData(
              api.guest.recapExtClass.city({
                provinceCode: search.province_code ?? '',
                cityCode: search.city_code ?? ''
              })
            )
            .catch(console.error)
        }
      }
    },
    component: RouteComponent,
    validateSearch: searchParamsSchema
  }
)

function RouteComponent() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  const filters = useFilters()

  return (
    <RecapClassificationsBPPtionsPage
      activeTab={search.tab}
      searchParams={{
        province_code: search.province_code,
        city_code: search.city_code
      }}
      onTabChange={tab => {
        const fn = match(tab)
          .with('national', () => filters.reset)
          .with('province', () => filters.onProvinceChange)
          .with('city', () => filters.onCityChange)
          .otherwise(() => filters.reset)

        const params = match(tab)
          .with('province', () => ({
            id: '',
            code: search.province_code ?? ''
          }))
          .with('city', () => ({ id: '', code: search.city_code ?? '' }))
          .otherwise(() => undefined)

        fn(params, false)
        navigate({ search: { ...search, tab } })
      }}
    />
  )
}
